import React, { useState, useEffect } from 'react';
import { Table, Form, Button, Modal, Card } from "react-bootstrap";
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPen, faPlus, faTrash, faFilter, faSync } from '@fortawesome/free-solid-svg-icons';
import useFetch from "../../../../hooks/useFetch";
import RequireRoles from '../../../../components/RequireRoles';
import PaginatedItems from '../../../../components/administracao/Pagination';
import Swal from 'sweetalert2';

export default function GerenciarTermos() {
    const { params } = useParams();
    const { get, del } = useFetch();

    const defaultState = {
        termos: [],
        count: 0,
        filtros: { palavra: "" },
        filtroAtivo: false,
        loading: true,
        mostrarModal: false,
        registroAExcluir: {}
    };

    const [state, setState] = useState(() => defaultState);

    useEffect(() => {
        async function initialize() {
            let [termos, count] = await buscarTermos({});
            setState(s => ({ ...s, termos, count, loading: false }));
        }
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    async function buscarTermos(filtros) {
        let query = "?";
        if (filtros && Object.keys(filtros).length > 0) {
            for (const key in filtros) {
                if (filtros[key] !== "") query = query.concat(key, "=", filtros[key], "&");
            }
        }
        try {
            let response = await get('/termoiconografia' + query);
            if (response.ok) {
                let dados = response.result;
                return [dados.data, dados.count];
            }
            return [[], 0];
        } catch (error) {
            console.error('Erro no buscarTermos():', error);
            return [[], 0];
        }
    }

    async function handlePageChange(pageNumber) {
        window.scrollTo(0, 0);
        let filtros = state.filtroAtivo ? { ...state.filtros, page: pageNumber } : { page: pageNumber };
        let [termos, count] = await buscarTermos(filtros);
        setState({ ...state, termos, count, loading: false });
    }

    const filtrarTermos = async () => {
        let [termos, count] = await buscarTermos(state.filtros);
        setState(s => ({ ...s, termos, count, filtroAtivo: true, loading: false }));
    };

    const limparFiltros = async () => {
        let [termos, count] = await buscarTermos({});
        setState(s => ({ ...s, filtros: defaultState.filtros, termos, count, filtroAtivo: false, loading: false }));
    };

    function handleChangeFiltros(event) {
        const { name, value } = event.target;
        setState(s => ({ ...s, filtros: { ...s.filtros, [name]: value } }));
    }

    async function excluirTermo() {
        let termo = state.registroAExcluir;
        try {
            let response = await del('/termoiconografia/' + termo.id_termo1 + '/' + termo.id_termo2);
            if (response.status === 200) {
                let [termos, count] = await buscarTermos(state.filtroAtivo ? state.filtros : {});
                setState({ ...state, termos, count, mostrarModal: false, registroAExcluir: {}, loading: false });
            } else {
                Swal.fire({ title: "Não foi possível excluir", text: response.result?.message ?? "Erro inesperado, tente novamente.", icon: "error", confirmButtonColor: "#587b7f" });
            }
        } catch (error) {
            console.error('Erro no excluirTermo():', error);
            Swal.fire({ title: "Erro de conexão", text: "Não foi possível falar com o servidor. Verifique sua conexão e tente novamente.", icon: "error", confirmButtonColor: "#587b7f" });
        }
    }

    return (
        <div className="admin-page-container">
            <div className="admin-header-container">
                <div className="title-group">
                    <h2 className="admin-title">Gerenciamento de Termos</h2>
                    <p className="admin-subtitle">Gerencie as relações de sinônimos e termos técnicos para o acervo iconográfico</p>
                </div>
                <Link to="/admin/iconografico/termos/criar/criar" className="btn-add-new">
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Novo Termo
                </Link>
            </div>

            <Card className="filter-card-admin mb-4">
                <Card.Body className="p-4">
                    <Form onSubmit={(e) => { e.preventDefault(); filtrarTermos(); }}>
                        <div className="row align-items-end">
                            <Form.Group className="col-md-8">
                                <Form.Label className="label-admin">Termo</Form.Label>
                                <Form.Control
                                    className="input-moderno"
                                    placeholder="Buscar por palavra..."
                                    name="palavra"
                                    value={state.filtros.palavra}
                                    onChange={handleChangeFiltros}
                                />
                            </Form.Group>
                            <div className="col-md-4 d-flex gap-2">
                                <Button type="button" className="btn-apply-filters w-100" onClick={filtrarTermos}>
                                    <FontAwesomeIcon icon={faFilter} className="me-2" /> Filtrar
                                </Button>
                                <Button type="button" className="btn-clear-filters" onClick={limparFiltros} title="Limpar">
                                    <FontAwesomeIcon icon={faSync} />
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Card.Body>
            </Card>

            <Card className="table-card-admin">
                <div className="table-responsive">
                    <Table className="modern-table mb-0">
                        <thead>
                            <tr>
                                <th>Termo Principal</th>
                                <th>Termo Relacionado</th>
                                <th className="text-center">Opções</th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.loading ? (
                                <tr><td colSpan="3" className="text-center py-5"><div className="spinner-border text-teal"></div></td></tr>
                            ) : state.termos.length > 0 ? (
                                state.termos.map((item, index) => (
                                    <tr key={index}>
                                        <td data-label="Termo Principal" className="fw-bold">{item.Termo1?.palavra}</td>
                                        <td data-label="Termo Relacionado" className="text-muted">{item.Termo2?.palavra}</td>
                                        <td data-label="Opções">
                                            <div className="d-flex justify-content-center gap-2">
                                                <Link className="action-icon view" to={`/admin/iconografico/termos/${item.id_termo1}/${item.id_termo2}`} state={{ acao: "Visualizar" }}><FontAwesomeIcon icon={faEye} /></Link>
                                                <Link className="action-icon edit" to={`/admin/iconografico/termos/${item.id_termo1}/${item.id_termo2}`} state={{ acao: "Editar" }}><FontAwesomeIcon icon={faPen} /></Link>
                                                <RequireRoles allowedRoles={['Desenvolvedor', 'Administrador']}>
                                                    <button className="action-icon delete" onClick={() => setState({ ...state, mostrarModal: true, registroAExcluir: item })}><FontAwesomeIcon icon={faTrash} /></button>
                                                </RequireRoles>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="3" className="text-center py-4">Nenhum termo encontrado.</td></tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                {state.termos.length > 0 && (
                    <div className="card-footer bg-white border-0 py-3 d-flex justify-content-center">
                        <PaginatedItems itemCount={state.count} itemsPerPage={20} handlePageChange={handlePageChange} />
                    </div>
                )}
            </Card>

            <Modal show={state.mostrarModal} onHide={() => setState({ ...state, mostrarModal: false })} centered className="modern-modal">
                <Modal.Header closeButton className="modal-header-teal">
                    <Modal.Title className="text-white fs-5">Excluir Termo</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <p className="mb-0">Deseja excluir a relação entre <strong>{state.registroAExcluir.Termo1?.palavra}</strong> e <strong>{state.registroAExcluir.Termo2?.palavra}</strong>?</p>
                </Modal.Body>
                <Modal.Footer className="border-0 p-4 pt-0">
                    <Button variant="light" onClick={() => setState({ ...state, mostrarModal: false })}>Cancelar</Button>
                    <Button variant="danger" className="px-4" onClick={excluirTermo}>Confirmar Exclusão</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
